//#region Imports
import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatDialog} from '@angular/material/dialog';
import {MatTabGroup} from '@angular/material/tabs';
import {LocalStorageService} from '../../../../../services/local-storage.service';
import {AddRowDialogComponent} from './add-row-dialog/add-row-dialog.component';
import {Router} from '@angular/router';
import {CreateFieldDialogComponent} from '../../../create-field-dialog/create-field-dialog.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {
    ResumesEditorSettingsDialogComponent
} from '../resumes-editor-settings-dialog/resumes-editor-settings-dialog.component';
import {FormTemplatesComponent} from '../form-templates/form-templates.component';
import {ConfirmDialogComponent} from '../../../../shared/confirm-dialog/confirm-dialog.component';
import {EditorService} from '../../../../../services/editor.service';
import {ToastMessagesService} from '../../../../../services/toast-messages.service';
import {ResumeService} from '../../../../../services/resume.service';

//#endregion

@Component({
    selector: 'app-grid-view',
    templateUrl: './grid-view.component.html',
    styleUrls: ['./grid-view.component.scss']
})
export class GridViewComponent implements OnInit {
    //#region Initializations
    @Input() formOptions: any;
    rows: any[] = [];
    rowIndexSelected = -1;
    memberSelected = {
        rowIndex: -1,
        memberIndex: -1
    };
    @ViewChild('endForm', {static: true}) endForm: ElementRef;
    @ViewChild('tabs', {static: false}) tabs: MatTabGroup;
    form = {
        settings: {
            language: {
                multi: false,
                languages: [{id: 1, value: 'EL'}, {id: 2, value: 'EN'}],
                default: 1,
                preview: 1,
                position: 'end center'
            },
            gapRow: '45px',
            gap: '15px',
            title: '',
            hasTwoFactor: false,
            canEditAfterSubmit: true,
        },
        uniqueId: '',
        rows: this.rows,
        questions: []
    };
    isDialogOpen: boolean;
    isDragging: boolean;
    types = [{type: 'text', name: 'Κείμενο'}, {type: 'date', name: 'Ημερομηνία'}, {
        type: 'radio',
        name: 'Πολλαπλή Επιλογή'
    }, {type: 'file', name: 'Αρχείο'}, {type: 'textarea', name: 'Περιοχή κειμένου'},
        {type: 'dropdown', name: 'Λίστα'}, {type: 'label', name: 'Απλό κείμενο'}, {type: 'image', name: 'Εικόνα'},
        {type: 'checkbox', name: 'Check box'}, {type: 'conditional-selector', name: 'Λίστα δυναμικής σύνδεσης'}];
    innerHeight: number;
    isLoading: boolean;
    displayBorders: boolean;
    selectedData: any;
    pageLoaded: boolean;
    templateName: string;
    isTemplateNameFieldShown: boolean;
    isTemplateSaving: boolean;
    pageLoading: boolean;
    linking = {
        isLinkRowMode: false,
        value: {},
    };
    controlKeys = {};
    //#endregion

    //#region Constructor and Life Cycle Hooks
    constructor(public dialog: MatDialog,
                private localStorageService: LocalStorageService,
                public toastService: ToastMessagesService,
                private resumeService: ResumeService,
                private editorService: EditorService,
                public router: Router) {
        this.innerHeight = window.innerHeight - 180;
        this.isDragging = false;
        this.isDialogOpen = false;
        this.rows = [];
        this.displayBorders = false;
        this.isLoading = false;
        this.pageLoaded = false;
        this.templateName = '';
        this.isTemplateNameFieldShown = false;
        this.isTemplateSaving = false;
        this.pageLoading = false;
        for (const record of this.types) {
            this.controlKeys[record.type] = 0;
        }
    }

    async ngOnInit(): Promise<void> {
        await this.initializeTemplates();
        if (this.formOptions.mode === 'edit' || this.formOptions.mode === 'preview') {
            await this.fetchForm(this.formOptions.id);
        }
        this.types.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        this.selectedData = {
            title: 'Ρυθμίσεις φόρμας',
            form: this.form,
            mode: 'form'
        };
        this.pageLoaded = true;
        const display = this.shouldDisplayHelperSettingsDialog();
        if (display) {
            // this.showHelp();
        }
    }


    async fetchForm(id: number) {
        try {
            this.pageLoading = true;
            const data = await this.resumeService.fetchResumeById(id);
            this.form = this.editorService.initializeForm(data.object);
            this.rows = this.form.rows;
            this.rows.map(row => {
                row.members.map(member => {
                        Object.keys(this.controlKeys).map(key => {
                            if (!member.hasOwnProperty('labelColor')) { member.labelColor = '#000000'; }
                            if (!member.hasOwnProperty('hiddenValue')) { member.hiddenValue = ''; }
                            if (member.controls.length > 0 && member.controls[0].type === key) {
                                this.controlKeys[key]++;
                                if (!member.hasOwnProperty('key')) {
                                    member.key = `${key}_${this.controlKeys[key]}`;
                                }
                            }
                        });
                });
            });
            this.displayBorders = this.formOptions.mode === 'preview';
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.pageLoading = false;
        }
    }

    async initializeTemplates() {
        try {
            console.log('initializing templates');
            await this.editorService.initializeTemplates();
            this.toastService.toastMessages('Τα πρότυπα αρχικοποιήθηκαν');
        } catch (e) {
            console.log('error');
            this.toastService.toastErrorMessage(e.message);
        }
    }

    showHelp() {
        this.dialog.open(ResumesEditorSettingsDialogComponent, {
            width: '50%'
        });
    }


    //#endregion

    //#region Drag & Drop
    dragStarted() {
        this.isDragging = true;
    }

    dragEnded() {
        this.isDragging = false;
    }

    drop(event: CdkDragDrop<string[]>, row: any, member: any) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            member.controls = [event.previousContainer.data[event.previousIndex]];
            this.controlKeys[member.controls[0].type]++;
            member.key = `${member.controls[0].type}_${this.controlKeys[member.controls[0].type]}`;
        }

        this.showSettingsTab({
            title: 'Μορφοποίηση πεδίου',
            member,
            mode: 'member'
        });

        const rowIndex = this.rows.findIndex(r => r.id === row.id);
        const memberIndex = row.members.findIndex(m => m.id === member.id);
        this.setSelectedMemberIndex(rowIndex, memberIndex);
    }

    showSettingsTab(selectedData) {
        this.pageLoaded = false;
        this.selectedData = selectedData;
        this.pageLoaded = true;
        this.tabs.selectedIndex = 1;
    }

    //#endregion

    //#region Dialogs
    showTemplates(): void {
        if (this.isDialogOpen) {
            return;
        }
        this.isDialogOpen = true;
        const dialog = this.dialog.open(FormTemplatesComponent, {
            hasBackdrop: false,
            disableClose: false,
        });
        dialog.afterClosed().subscribe(rows => {
            this.isDialogOpen = false;
            if (rows) {
                if (this.rows.length > 0) {
                    const confirm = this.dialog.open(ConfirmDialogComponent, {
                        data: {
                            message: 'Υπάρχουν ήδη στοιχεία στη φόρμα σας. Θέλετε να τα αντικαταστήσετε?',
                            title: 'Αντικατάσταση φόρμας',
                            icon: 'reload',
                            iconColor: 'blue',
                        }
                    });
                    confirm.afterClosed().subscribe(response => {
                        if (response) {
                            this.assignRows(rows);
                        }
                    });
                } else {
                    this.assignRows(rows);
                }

            }
        });
    }

    showSettings() {
        this.showSettingsTab({
            title: 'Ρυθμίσεις φόρμας',
            form: this.form,
            mode: 'form'
        });
    }

    editRow(row: any) {
        const index = this.rows.findIndex(r => row.id === r.id);
        this.setSelectedRowIndex(index);
        this.showSettingsTab({
            title: 'Μορφοποίηση γραμμής',
            row,
            rows: this.rows,
            mode: 'row'
        });
    }

    editMember(member: any, rowIndex: number, memberIndex: number) {
        this.showSettingsTab({
            title: 'Μορφοποίηση πεδίου',
            member,
            mode: 'member'
        });

        this.setSelectedMemberIndex(rowIndex, memberIndex);
    }

    //#endregion

    //#region Helpers
    closeEvent($event: any) {
        this.tabs.selectedIndex = 0;
        this.rowIndexSelected = -1;
        this.memberSelected = {
            rowIndex: -1,
            memberIndex: -1
        };
    }

  displayFieldName(member: any) {
    return +this.form.settings.language.preview === 2 ? member.labelEN : member.label;
  }

  displayRowName(row: any) {
    return +this.form.settings.language.preview === 2 ? row.title.textEN : row.title.text;
  }

  displayPlaceHolder(member: any) {
    return +this.form.settings.language.preview === 2 ? member.placeholderEN : member.placeholder;
  }

  displayValueLabel(member) {
    return +this.form.settings.language.preview === 2 ? member.valueEN : member.value;
  }

    isRowSelected(index: number) {
        return this.rowIndexSelected === index;
    }

    setSelectedRowIndex(index) {
        this.rowIndexSelected = index;
    }

    isMemberSelected(rowIndex: number, memberIndex: number) {
        return this.memberSelected.rowIndex === rowIndex && this.memberSelected.memberIndex === memberIndex;
    }

    setSelectedMemberIndex(rowIndex: number, memberIndex: number) {
        this.memberSelected.rowIndex = rowIndex;
        this.memberSelected.memberIndex = memberIndex;
    }

    shouldDisplayHelperSettingsDialog(): boolean {
        let shouldDisplay = true;
        try {
            const display = this.localStorageService.get('displayHelper');
            if (display === null) {
                shouldDisplay = true;
            } else {
                shouldDisplay = display === 'true';
            }
        } catch (e) {
            shouldDisplay = true;
        }

        return shouldDisplay;
    }

    toggleBorders() {
        this.displayBorders = !this.displayBorders;
    }

    addRow() {
        this.rows.push(this.editorService.createRow(this.rows.length + 1, 1));
        this.endForm.nativeElement.scrollIntoView({behavior: 'smooth'});
    }

    assignRows(rows: any) {
        this.rows = [...rows];
    }

    calculateFlex(members) {
        return (100 / members);
    }

    moveUp(row: any) {
        const rows = [...this.rows];
        const currentRowIndex = rows.findIndex(r => r.id === row.id);
        if (currentRowIndex !== -1 && currentRowIndex !== 0) {
            const previousIndex = currentRowIndex - 1;
            const tempRow = rows[previousIndex];
            rows[previousIndex] = rows[currentRowIndex];
            rows[currentRowIndex] = tempRow;
        }

        this.rows = rows;
    }

    duplicateRow(row: any, rowIndex: number) {
        const newRow = JSON.parse(JSON.stringify(row));
        newRow.id = this.rows.length + 1;
        this.rows.splice(rowIndex, 0, newRow);
    }

    moveDown(row: any) {
        const rows = [...this.rows];
        const currentRowIndex = rows.findIndex(r => r.id === row.id);
        if (currentRowIndex - 1 < rows.length) {
            const nextIndex = currentRowIndex + 1;
            const tempRow = rows[nextIndex];
            rows[nextIndex] = rows[currentRowIndex];
            rows[currentRowIndex] = tempRow;
        }

        this.rows = rows;
    }

    shouldDisableUpButton(row: any): boolean {
        const currentRowIndex = this.rows.findIndex(r => r.id === row.id);
        return currentRowIndex <= 0;
    }

    shouldDisableDownButton(row: any): boolean {
        const currentRowIndex = this.rows.findIndex(r => r.id === row.id);
        return currentRowIndex >= this.rows.length - 1;
    }

    deleteMember(row: any, index: number) {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τη στήλη?',
                title: 'Διαγραφή στήλης',
                icon: 'delete',
                iconColor: 'red'
            }
        });
        confirm.afterClosed().subscribe(response => {
            if (response) {
                row.members.splice(index, 1);
                row.columns--;
            }
        });
    }

    removeMember(member: any) {
        this.controlKeys[member.controls[0].type]--;
        member.controls = [];
        member.options = [];
        member.value = '';
        this.selectedData = {
            title: 'Ρυθμίσεις φόρμας',
            form: this.form,
            mode: 'form'
        };
        this.tabs.selectedIndex = 0;
    }

    deleteRow(index: number) {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τη γραμμή?',
                title: 'Διαγραφή γραμμής',
                icon: 'delete',
                iconColor: 'red'
            }
        });
        confirm.afterClosed().subscribe(response => {
            this.rows.splice(index, 1);
        });
    }

    //#endregion

    //#region Save and Update events
    async update(): Promise<void> {
        const data = {
            message: 'Είστε σίγουροι ότι θέλετε να ενημερώσετε τη φόρμα?',
            title: 'Ενημέρωση φόρμας',
            icon: 'update',
            iconColor: 'green'
        };
        await this.saveOrUpdateProcess(data, true);
    }

    async save(): Promise<void> {
        const data = {
            message: 'Είστε σίγουροι ότι θέλετε να αποθηκεύσετε τη φόρμα?',
            title: 'Αποθήκευση φόρμας',
            icon: 'save',
            iconColor: 'green'
        };
        await this.saveOrUpdateProcess(data, false);
    }

    async saveOrUpdateProcess(data: any, isUpdate: boolean = false) {
        const confirm = this.dialog.open(ConfirmDialogComponent, {data});
        confirm.afterClosed().subscribe(async response => {
            if (response) {
                try {
                    this.isLoading = true;
                    this.isTemplateSaving = true;

                    const questions = [];
                    const rows = JSON.stringify(this.rows);
                    for (const row of this.rows) {
                        for (const member of row.members) {
                            if (member.shouldExport) {
                                questions.push(member);
                            }
                        }
                    }

                    const form = {
                        settings: JSON.stringify(this.form.settings),
                        rows,
                        questions: JSON.stringify(questions)
                    };

                    let message = '';
                    if (isUpdate) {
                        await this.editorService.updateForm(form, this.form.uniqueId);
                        message = 'Η φόρμα ενημερώθηκε με επιτυχία';
                    } else {
                        await this.editorService.saveForm(form);
                        message = 'Η φόρμα αποθηκεύτηκε με επιτυχία';
                    }
                    this.toastService.toastMessages(message);
                } catch (e) {
                    this.toastService.toastErrorMessage(e.message);
                } finally {
                    this.isLoading = false;
                    this.isTemplateSaving = false;
                }
            }
        });
    }

//#endregion

    //#region Templating

    createTemplate() {
        this.isTemplateNameFieldShown = true;
    }

    saveTemplate() {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                message: 'Είστε σίγουροι ότι Θέλετε να αποθηκεύσετε το πρότυπο?',
                title: 'Αποθήκευση προτύπου',
                icon: 'save',
                iconColor: 'blue',
            }
        });
        confirm.afterClosed().subscribe(async response => {
            if (response) {
                const template = {
                    name: this.templateName,
                    rows: JSON.stringify(this.rows)
                };

                try {
                    this.isTemplateSaving = true;
                    await this.editorService.createTemplate(template);
                    this.templateName = '';
                    this.isTemplateNameFieldShown = false;
                    this.toastService.toastMessages('Το πρότυπό σας αποθηκεύτηκε με επιτυχία');
                } catch (e) {
                    this.toastService.toastErrorMessage(e.message);
                } finally {
                    this.isTemplateSaving = false;
                }
            }
        });
    }

    cancelTemplateSaving() {
        this.templateName = '';
        this.isTemplateNameFieldShown = false;
    }

    //#endregion

    //#region Linking
    isCheckDisabled(rowIndex: number) {
        const row = this.rows[rowIndex];
        if (!row.hasLink) {
            return false;
        } else {
            return JSON.stringify(row.linkValue) !== JSON.stringify(this.linking.value);
        }
    }

    checkedChange($event: MatCheckboxChange, rowIndex: number) {
        const row = this.rows[rowIndex];
        if ($event.checked) {
            row.hasLink = true;
            row.linkValue = this.linking.value;
        } else {
            row.hasLink = false;
            row.linkValue = null;
        }
    }

    isChecked(rowIndex: number) {
        if (!this.rows[rowIndex].hasLink) { return false; }
        return  JSON.stringify(this.rows[rowIndex].linkValue) === JSON.stringify(this.linking.value);
    }

    startLinking($event) {
        console.log($event);
        if ($event.active) {
            this.linking = {
                isLinkRowMode: true,
                value: $event.value
            };
        } else {
            this.linking = {
                isLinkRowMode: false,
                value: null
            };
        }
    }
    //#endregion

    setPreviewLanguage(id: number) {
        this.form.settings.language.default = id;
        this.form.settings.language.preview = id;
    }
}
